/* eslint-disable @typescript-eslint/no-explicit-any */
import type { HttpRequest } from '@angular/common/http';
import type { spriMockApiReplyCallback } from '@spri/lib/mock-api/mock-api.types';
import { Observable, of, take, throwError } from 'rxjs';

export class spriMockApiHandler {
  request!: HttpRequest<any>;
  urlParams!: Record<string, string>;

  // Private
  private replyCallback: spriMockApiReplyCallback = undefined;
  private replyCountValue = 0;
  private replied = 0;

  constructor(
    public url: string,
    public delay?: number
  ) {}

  /**
   * Getter for response callback
   */
  public get response(): Observable<any> {
    // If the execution limit has been reached, throw an error
    if (this.replyCountValue > 0 && this.replyCountValue <= this.replied) {
      return throwError(() => 'Execution limit has been reached!');
    }

    // If the response callback has not been set, throw an error
    if (!this.replyCallback) {
      return throwError(() => 'Response callback function does not exist!');
    }

    // If the request has not been set, throw an error
    if (!this.request) {
      return throwError(() => 'Request does not exist!');
    }

    // Increase the replied count
    this.replied++;

    // Execute the reply callback
    const replyResult = this.replyCallback({
      request: this.request,
      urlParams: this.urlParams,
    });

    // If the result of the reply callback is an observable...
    if (replyResult instanceof Observable) {
      // Return the result as it is
      return replyResult.pipe(take(1));
    }

    // Otherwise, return the result as an observable
    return of(replyResult).pipe(take(1));
  }

  /**
   * Reply
   *
   * @param callback
   */
  public reply(callback: spriMockApiReplyCallback): void {
    // Store the reply
    this.replyCallback = callback;
  }

  /**
   * Reply count
   *
   * @param count
   */
  public replyCount(count: number): void {
    // Store the reply count
    this.replyCountValue = count;
  }
}
